import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(8),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
      },
    },
    customerInfoTitle: {
      fontSize: 14,
      lineHeight: 1.2,
      fontWeight: 500,
      margin: '30px 0 8px 0',
      color: theme.oysterTheme.shark,
    },
    customerInfoDesc: {
      fontSize: 14,
      lineHeight: 1.2,
      color: theme.oysterTheme.obsidian,
    },
    contactInfoRow: {
      padding: '5px 0',
      '& svg path': {
        fill: ({ secondaryColor }: StyleProps) => secondaryColor,
        opacity: 0.6,
      },
    },
    hide: {
      display: 'none',
    },
    checkoutTitle: {
      fontWeight: 'bold',
      fontSize: 24,
      textAlign: 'center',
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(2),
        textAlign: 'left',
      },
    },
    detailSection: {
      width: '100%',
      maxWidth: 384,
      flexBasis: '100%',
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        maxWidth: 'none',
        alignItems: 'center',
        flexDirection: 'column',
      },
    },
    paymentSection: {
      width: '100%',
      marginTop: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        marginTop: 0,
        maxWidth: 384,
        flexBasis: '100%',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        maxWidth: 'none',
        alignItems: 'center',
        flexDirection: 'column',
      },
    },
    useOyster: {
      display: 'none',
      maxWidth: '380px',

      '& a': {
        color: theme.oysterTheme.oyster,
      },

      [theme.breakpoints.up('sm')]: {
        display: 'block',
        fontSize: 14,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        textAlign: 'center',
        color: theme.oysterTheme.shark,
        '& a': {
          fontWeight: 600,
          fontSize: 14,
        },
      },
    },
    contactsContainer: {
      width: '100%',
      maxWidth: 380,
      [theme.breakpoints.down('sm')]: {
        padding: `0 ${theme.spacing(2)}px`,
      },
    },
    paymentSuccessContainer: {
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column-reverse',
      },
    },
  }),
);

export default useStyles;
